// extracted by mini-css-extract-plugin
export default {"bigStatTitle":"BigStat_bigStatTitle__scCeq","arrowAlign":"BigStat_arrowAlign__gUSW4","dropdown":"BigStat_dropdown__RQlE-"};